export namespace SidebarActions {
    export class TogglePersonalPanelExpanded {
        public static readonly type = "[Sidebar] TogglePersonalPanelExpanded";
    }
}
